import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "loader" }, null, -1),
        _createElementVNode("div", { class: "loader-section section-left" }, null, -1),
        _createElementVNode("div", { class: "loader-section section-right" }, null, -1)
      ])))
    : _createCommentVNode("", true)
}